import { LoadingView } from '@payflip/ui/v2';
import { lazy, MouseEventHandler, Suspense, useRef } from 'react';
import { useNavigate, useOutletContext } from 'react-router';
import { ManualSigningOutlet } from '../../outlets/budget-activation/manual-signing-outlet/manual-signing-outlet';
import { ChoiceDetails } from '../../outlets/choice-details';
import { Overlay, SideScreen } from './styled';

const BudgetActivation = lazy(() => import('../../outlets/budget-activation'));
const RequestCashoutBudgetList = lazy(
  () => import('../../outlets/request-cashout/request-cashout-budget-list')
);

const RequestCashoutAmount = lazy(
  () => import('../../outlets/request-cashout/request-cashout-amount')
);

const outletTypes = [
  'BUDGET_ACTIVATION',
  'CHOICE_DETAILS',
  'REQUEST_CASHOUT_BUDGET_LIST',
  'REQUEST_CASHOUT_AMOUNT',
  'MANUAL_BUDGET_ACTIVATION'
] as const;

type OutletType = (typeof outletTypes)[number];

interface OutletProps {
  type: OutletType;
}

export function Outlet({ type }: OutletProps): JSX.Element {
  const { goBackTo } = useOutletContext<{ goBackTo: string }>();
  const navigate = useNavigate();
  const sideScreenRef = useRef<HTMLDivElement>(null);

  const handleOverlayClick: MouseEventHandler<HTMLDivElement> = (e) => {
    if (
      sideScreenRef.current !== null &&
      sideScreenRef.current.contains(e.target as Node) === false
    ) {
      navigate(goBackTo, { replace: true });
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <SideScreen ref={sideScreenRef}>
        <Suspense fallback={<LoadingView />}>
          {type === 'BUDGET_ACTIVATION' && <BudgetActivation />}
          {type === 'MANUAL_BUDGET_ACTIVATION' && <ManualSigningOutlet />}
          {type === 'CHOICE_DETAILS' && <ChoiceDetails />}
          {type === 'REQUEST_CASHOUT_BUDGET_LIST' && (
            <RequestCashoutBudgetList />
          )}
          {type === 'REQUEST_CASHOUT_AMOUNT' && <RequestCashoutAmount />}
        </Suspense>
      </SideScreen>
    </Overlay>
  );
}
